const keys = {
  update_user: "update_user",
  payload: "payloade_user",
  connect: "connecte_user",
  all: "all_user",
  setStDemands: "setStDemands",
};

export default keys;
